import React from 'react';
import { Flex, Box, Stack, Text, Heading, Link } from '@chakra-ui/react';

interface CustomerQuoteProps {
  image: React.ReactNode;
  quote: string;
  title?: string;
  authorDescription: string;
}

const CustomerQuoteSection = ({
  image,
  quote,
  title,
  authorDescription,
}: CustomerQuoteProps) => (
  <Stack
    as={Flex}
    alignItems="center"
    my={['16', '20', '24']}
    maxW="8xl"
    mx="auto"
  >
    <Heading fontSize={['3xl', '4xl', '5xl', '5xl']} mb="16">
      {title}
    </Heading>
    <Flex alignItems="flex-start" justifyContent="center" px={[4, 6, 16]}>
      {image}
      <Box ml={[3, 4, 5]}>
        <Text fontSize={['xl', '2xl', '3xl']} mb={4}>
          {quote}
        </Text>
        <Text fontSize={['md', 'lg', 'xl']}>
          {authorDescription} |{' '}
          <Link href="/customers/" color="blue.300">
            Learn more about our customers and partners.
          </Link>
        </Text>
      </Box>
    </Flex>
  </Stack>
);

CustomerQuoteSection.defaultProps = {
  title: 'Happy Customers',
};

export default CustomerQuoteSection;
